import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFullScreen } from 'react-browser-hooks';
import { isMobile, isIOS  } from 'react-device-detect';
import '../assets/stylesheets/FullScreen.scss';
// Preventint zoom on tap/zoom in iOS
//
if(isIOS) {
    const prevent = e => e.preventDefault();
    document.body.addEventListener('gesturechange', prevent);
    document.body.addEventListener('gesturestart', prevent);
    document.body.addEventListener('gestureend', prevent);
} 
if(!isMobile) {
    window.addEventListener('resize', e => window.resizeTo(400, 800));
}

const ForceFullScreen = () => {
    const { t } = useTranslation();
    const androidFSDetector = useFullScreen();
    const iOSFullScreened = useDetectIosFs();
    const [exitFullScreen, setExitFullScreen] = useState(false);
    console.log('iOSFullScreened: ', iOSFullScreened);

    const goFullScreen = () => {
        if (document.documentElement.requestFullScreen) {
            window.document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            window.document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
            window.document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    }
    return (
        <React.Fragment>
            {isMobile && !isIOS && !androidFSDetector.fullScreen &&
                <div className={`fullScreenForcer android`} onClick={goFullScreen}></div>
            }
            { isIOS && !iOSFullScreened && !exitFullScreen &&
                <div className={`fullScreenForcer iOS`}>
                    <span className={`hintText`}>{t('fullScreenHint')}</span>
                    <span className={`exitFullScreen`} onClick={() => setExitFullScreen(true)}>{t('dismissFullScreen')}</span>
                </div>
            }
        </React.Fragment>
    )
};


// Special Hook
function useDetectIosFs() {
    function detectFS() {
        // console.log('outerHeight: ', window.outerHeight);
        // console.log('outerWidth: ', window.outerWidth);
        // console.log('orientation: ', window.orientation);
        return !!window && (window.orientation === 0) && (window.outerHeight - window.innerHeight > 100) ? false : true;
    }
    const [fsState, setFSState] = useState(detectFS);

    useEffect(() => {
        function handleResize() {
            setFSState(detectFS());
        }
        function orientationChange() {
            setFSState(detectFS());
        }
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', orientationChange);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', orientationChange);
        }
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return fsState;
}

export default ForceFullScreen;
